import config from '@/__config';
export default {
  namespaced: true,
  state: {
    currentUser: null,
    scopes: null,
    isAdministrator: false,
  },
  mutations: {
    SET_CURRENT_USER(state, data) {
      const userKey =
        config.auth.user && config.auth.user.userKey
          ? config.auth.user.userKey
          : 'user';
      state.currentUser = data[userKey] ? data[userKey] : data;
      state.scopes = data.scopes;
    },
    REMOVE_CURRENT_USER(state) {
      state.currentUser = null;
      state.scopes = null;
    },
    UPDATE_USER_COLLECT_ACT(state, data) {
      state.currentUser.act_ids = data;
    },
    SET_ADMINISTRATOR(state, data) {
      state.isAdministrator = data;
    },
  },
  actions: {
    setCurrentUser({ commit }, data) {
      commit('SET_CURRENT_USER', data);
    },
    removeCurrentUser({ commit }) {
      commit('REMOVE_CURRENT_USER');
    },
    updateUserCollectAct({ commit }, data) {
      commit('UPDATE_USER_COLLECT_ACT', data);
    },
    setAdministrator({ commit }, data) {
      commit('SET_ADMINISTRATOR', data);
    },
  },
};
